import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  padding: 38px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
const Content = styled.div`
  width: 100%;
  padding-bottom: 32px;
  border-bottom: 1px solid #e1e2e4;
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

const ProfileBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
const ProfileInner = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
`;
const ProfileTitle = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  font-family: Spoqa Han Sans Neo;
  font-size: 16px;
  font-weight: 500;
  color: #222;
`;
const LogOutButton = styled.div`
  width: 100%;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Spoqa Han Sans Neo;
  font-size: 16px;
  font-weight: 500;
  color: rgba(55, 56, 60, 0.61);
  cursor: pointer;
`;
const ChangeProfileButton = styled.div`
  width: 100%;
  height: 44px;
  display: flex;
  padding: 9px 16px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: #008aff;
  font-family: Spoqa Han Sans Neo;
  font-size: 16px;
  font-weight: 500;
  color: white;
  cursor: pointer;
`;

const InfoBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
const InfoTitle = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-size: 16px;
  font-weight: 700;
  color: #222;
`;
const InfoRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
const InfoItem = styled.div`
  display: flex;
  flex-direction: row;
  gap: 32px;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  color: #616161;
`;
const InfoLabel = styled.div`
  width: 67px;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 700;
  color: #616161;
  white-space: nowrap;
`;
const ChangeButton = styled.span`
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  color: #008aff;
  cursor: pointer;
`;
const Greeting = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 4px;
`;
const Name = styled.span`
  font-weight: 700;
`;
const EmailInfo = styled.span`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
`;

const EditBox = styled.div`
  width: 180px;
  padding: 8px 0;
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 30px;
  right: 0;
  border-radius: 16px;
  background-color: #fff;
  box-shadow:
    0px 2px 8px 0px rgba(0, 0, 0, 0.12),
    0px 1px 4px 0px rgba(0, 0, 0, 0.08),
    0px 0px 1px 0px rgba(0, 0, 0, 0.08);
  z-index: 999;
`;
const EditBoxRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
`;

export const s = {
  Container,
  Content,
  LogOutButton,
  ProfileBox,
  ProfileInner,
  ProfileTitle,
  ChangeProfileButton,
  InfoBox,
  InfoTitle,
  InfoRow,
  InfoItem,
  InfoLabel,
  ChangeButton,
  Name,
  Greeting,
  EmailInfo,
  EditBox,
  EditBoxRow,
};
